import { Box, Grid, TableCell } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectLoggedInUser } from "../../../features/auth/auth.slice";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import StyledTableRow from "../../../components/table/styled-table-row";
import TableActionButton from "../../../components/table/table-action-button";
import { StaffAttendance, StaffAttendanceRequest } from "../../../service/model/staff-attendance.model";
import { DeleteIcon, EditIcon } from "../../../shared/icons";
import { deleteStaffAttendance, updateStaffAttendance } from "../staff-attendance.slice";
import { PermissionCode } from "../../../shared/enums";
import { getPermissionsForLoggedInUser } from "../../../shared/utils";
import StaffAttendanceForm from "./staff-attendance-form";

interface TableRowProps {
    readonly staffAttendance: StaffAttendance;
    readonly isProfileView?: boolean;
}

const StaffAttendanceTableRow: React.FC<TableRowProps> = ({ staffAttendance, isProfileView }) => {
    const dispatch = useAppDispatch();
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const loggedInUserPermissions = getPermissionsForLoggedInUser(loggedInUser);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showAttendanceForm, setShowAttendanceForm] = useState(false);

    const handleDelete = () => {
        dispatch(deleteStaffAttendance(staffAttendance.id));
        setShowDeleteDialog(false);
    };

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false);
    };

        const handleSubmit = (data: StaffAttendanceRequest) => {
            const updateRequest: StaffAttendanceRequest = {
                id: staffAttendance.id,
                ...data
            };
            dispatch(updateStaffAttendance(updateRequest)).then(resp => {
                if (resp.meta.requestStatus === 'fulfilled') {
                    setShowAttendanceForm(false);
                }
            });
        };

    return (
        <>
            <StyledTableRow key={staffAttendance.id}>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">
                        Name
                    </Box>
                    {staffAttendance.businessUserName}
                </TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">
                        Check In
                    </Box>
                    {staffAttendance.checkIn ? staffAttendance.checkIn.replace("T", " ") : "—"}
                </TableCell>
                {/* <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">
                        Check Out
                    </Box>
                    {staffAttendance.checkOut ? staffAttendance.checkOut.replace("T", " ") : "—"}
                </TableCell> */}
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">
                        Marked By
                    </Box>
                    {staffAttendance.markedBy || "—"}
                </TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">
                        Source
                    </Box>
                    {staffAttendance.source || "—"}
                </TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">
                        Actions
                    </Box>
                    <Grid display="flex">
                        {loggedInUserPermissions.includes(PermissionCode.STAFF_ATTENDANCE_EDIT) &&
                            <TableActionButton onClick={() => setShowAttendanceForm(true)} label="Edit" icon={<EditIcon />} disabled={isProfileView || staffAttendance.source === 'FINGERPRINT'} />
                        }
                        {loggedInUserPermissions.includes(PermissionCode.STAFF_ATTENDANCE_DELETE) &&
                            <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />}  disabled={isProfileView || staffAttendance.source === 'FINGERPRINT'} />
                        }
                    </Grid>
                </TableCell>
            </StyledTableRow>

            {showAttendanceForm &&
                <StaffAttendanceForm attendance={staffAttendance} editable={true} onClose={() => setShowAttendanceForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog && (
                <ConfirmationDialog
                    show={true}
                    message={
                        <>
                            Are you sure you want to delete attendance for <strong>{staffAttendance.businessUserName}</strong> on <strong>{staffAttendance.checkInDate || staffAttendance.checkIn?.substring(0, 10)}</strong>?
                        </>
                    }
                    onConfirm={handleDelete}
                    onCancel={handleDeleteCancel}
                />
            )}
        </>
    );
};

export default StaffAttendanceTableRow;
